/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  return {
    variables: {
      board_id: Array.isArray(props.boardId) ? props.boardId : [props.boardId],
    },
    pause: !props.boardId,
    requestPolicy: 'cache-and-network',
  }
}
